<template>
<div>
  <el-dialog
    title="Select field"
    :visible.sync="dialogVisibleUpdate"
    :close-on-click-modal="false" 
    @close="handleCloseUpdate"
    custom-class="dialog_dataService dc-download"
    :append-to-body="true"
    >
    <div class="dataCleaning-regenerate-dialog">
      <div class="dc-dialog-categoryField">
        <div class="dc-categoryField-filter">
          <el-input
            placeholder="Enter field name"
            prefix-icon="el-icon-search"
            clearable
            v-model="searchKeyword">
          </el-input>
        </div>
        <div class="dc-categoryField-scroll">
          <el-collapse v-model="dcDialogActiveNames" class="dc-categoryField-collapse">
            <el-checkbox-group v-model="selectedSecondKeys"
            class="dc-categoryField-checkbox"
            > 
              <!-- 第一层 -->
              <el-collapse-item 
              v-for="(level1, index) in filteredData"
              :key="'category'+index"
              :title="level1.name" 
              :name="index"
              
              >
                <div class="dc-categoryField-checkbox-item"
                v-for="(level2, level2Index) in level1.children"
                :key="'categorySub'+level2Index"
                >
                  <!-- 第二层 -->
                  <el-checkbox
                  :key="genKey(level1, level2)"
                  :label="genKey(level1, level2)"
                  >{{level2.name}}
                  </el-checkbox>
                  <div class="dc-categoryField-checkbox-open "
                  >
                    <i class="el-icon-arrow-right"></i>
                  </div>
                </div>
              </el-collapse-item>
            </el-checkbox-group>
          </el-collapse>
        </div>
      </div>
      <div class="dc-dialog-subfield">
        <div class="dc-categoryField-filter">&nbsp;</div>
        <div class="dc-categoryField-scroll resultgap">
          <div
          class="dc-categoryField-checkbox"
          >
            <!-- 第三层 -->
            <div class="dc-categoryField-checkbox-item"
            v-for="level3 in level3ListUpdate"
            :key="level3.id"
            >
              {{ level3.name }}
            </div>
          </div>
        </div>
      </div>
      <div class="dc-dialog-field-selected">
        <div class="dc-categoryField-filter selectedShow">Selected Columns ({{selectedIds && selectedIds.length}})</div>
        <div class="dc-categoryField-scroll">
          <div class="dc-categoryField-selected-list"
          v-for="combo in selectedTreeData"
          :key="'checkedList'+combo.level1.id"
          >
            <div class="dc-categoryField-item title">
              <div class="dc-categoryField-item-label">{{combo.level1.name}}</div>
              <div class="dc-categoryField-item-delete"
              @click.stop="removeLevel1(combo.level1)"
              >
                <i class="el-icon-close"></i>
              </div>
            </div>
            <div class="dc-categoryField-item-sublist">
              <div class="dc-categoryField-item"
              v-for="level2 in combo.selectedChildren"
              :key="'checkedListChildren'+level2.id"
              >
                <div class="dc-categoryField-item-label">{{level2.name}}</div>
                <div class="dc-categoryField-item-delete"
                @click.stop="removeLevel2(combo.level1, level2)"
                >
                  <i class="el-icon-close"></i>
                </div>
              </div>
            </div>
          </div>
          
        </div>
      </div>
    </div>
    <span slot="footer" class="dialog-footer dc-download-dialog-footer flex_center">
      <el-button 
      :disabled="selectedSecondKeys.length == 0"
      class="dc-download-btn"
      @click="handleDownload">Download</el-button>
      <el-button 
      :disabled="selectedSecondKeys.length == 0"
      type="primary" 
      class="dc-update-btn"
      @click="handleUpdate">Update </el-button>
      
    </span>
  </el-dialog>
  <!-- Remind -->
  <el-dialog
    title="Remind"
    class="dialog_modal remindDialog"
    :visible.sync="remindVisible"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    width="421px"
  >
    <div class="remind-dialog-content">
      <div class="remind-list">
        <div class="remind-item">
          <div class="remind-item-title">Selected Modules:</div>
          <div class="remind-item-num">{{selectedLevel1Ids.length}}</div>
        </div>
        <div class="remind-item">
          <div class="remind-item-title">Selected Fields:</div>
          <div class="remind-item-num">{{level3ListUpdate.length}}</div>
          
        </div>
        <div class="remind-item">
          <div class="remind-item-title">Company Count:</div>
          <div class="remind-item-num">{{aaaid.length}}</div>
        </div>
        <div class="remind-item cost">
          <div class="remind-item-title">Cost:</div>
          <div class="remind-item-num">Free for Testing Phase</div>
        </div>
        
      </div>
      <div class="remind-tips">Expected completion in 1-7 working days.</div>
    </div>
    <div class="dc-dialog-footer flex_center">
      <el-button type="primary" class="dc-remind-btn" @click="remindSubmit"
        >OK</el-button
      >
    </div>
  </el-dialog>
</div>
</template>

<script>
import { getMenuList, exportExcelData, exportMultiExcelDataForComplete, addMultiUpdateTask, calculatePrice } from "@/api/dataServicesApi";
export default {
  components: {
    
  },
  props: {
    dialogVisible: { type: Boolean, default: false },
    aaaid: { type: Array, default: [] },
    selectedCompanys: { type: Array, default: [] },
    type: { type: String, default: '' },
    taskId: { type: String, default: '' },

  },
  data() {
    return {
      dialogVisibleUpdate: false,
      menuList: [],//全部数据
      dcDialogActiveNames: [0],//默认展开第一个一级数据
      selectedSecondKeys: [],// 选中二级
      selectedTreeData: [],//选中的树形结构
      level3List: [],//展示的第三级
      level3ListShowId: '',// 选中二级id来展示对应三级并箭头高亮
      searchKeyword: '',//搜索关键字
      remindVisible: false,
      calculatePriceRes: {},
    };
  },
  watch: {
    dialogVisible: {
      handler(newVal) {
        this.dialogVisibleUpdate = newVal;
        if(newVal){
          this.menuList = [];
          this.toGetMenuList();
        } 
        
      },
      immediate: true
    },
    selectedSecondKeys: {
      handler(newKeys) {
        this.updateSelectedTreeData(newKeys);
      },
      immediate: true
    }
  },
  computed: {
    // 👇 新增：过滤后的数据
    filteredData() {
      if (!this.searchKeyword.trim()) {
        return this.menuList; // 无搜索时显示全部
      }

      const keyword = this.searchKeyword.trim().toLowerCase();
      return this.menuList.filter(level1 => {
        // 检查一级是否匹配
        const matchLevel1 = level1.name.toLowerCase().includes(keyword);
        // 检查是否有二级匹配
        const matchLevel2 = level1.children.some(child =>
          child.name.toLowerCase().includes(keyword)
        );
        return matchLevel1 || matchLevel2;
      });
    },
    selectedIds(){
      console.log(this.selectedTreeData)
      const selectedIds = this.selectedTreeData.reduce((acc, node) => {
        node.selectedChildren.forEach(level2 => {
          acc.push(level2.id);
        });
        return acc;
      }, []);
      return selectedIds;
    },
    // 一级id
    selectedLevel1Names(){
      // 直接映射一级节点的 ID
      return this.selectedTreeData.map(node => node.level1.name);
    },
    selectedLevel1Ids(){
      // 直接映射一级节点的 ID
      console.log(this.selectedTreeData.map(node => node.level1.id));
      return this.selectedTreeData.map(node => node.level1.id);
    },
    selectedNames(){
      const selectedNames = this.selectedTreeData.reduce((acc, node) => {
        node.selectedChildren.forEach(level2 => {
          acc.push(level2.name);
        });
        return acc;
      }, []);
      return selectedNames;
    },
    level3ListUpdate(){
      return this.selectedTreeData.flatMap(level1Item =>
        (level1Item.selectedChildren || []).flatMap(item => item.children || [])
      );
    },
  },
  methods: {
    genKey(l1, l2) {
      return `${l1.name}-${l2.name}`;
    },
    showLevel3List(row){
      this.level3List = row.children;
      this.level3ListShowId = row.id;
    },
    updateSelectedTreeData(keys) {
      const treeMap = new Map();

      // 按一级分组
      keys.forEach(key => {
        const [l1Name, l2Name] = key.split('-');
        const level1 = this.menuList.find(l1 => l1.name === l1Name);
        const level2 = level1.children.find(l2 => l2.name === l2Name);

        if (!treeMap.has(level1)) {
          treeMap.set(level1, {
            level1,
            selectedChildren: [],
            expanded: true
          });
        }
        treeMap.get(level1).selectedChildren.push(level2);
      });

      // 转为数组
      this.selectedTreeData = Array.from(treeMap.values());
      console.log('this.selectedTreeData',this.selectedTreeData);
      // 更新 activeLevel2（保持最新选中的在第二列）
      if (keys.length > 0) {
        const lastKey = keys[keys.length - 1];
        const [l1Name, l2Name] = lastKey.split('-');
        const level1 = this.menuList.find(l1 => l1.name === l1Name);
        const level2 = level1.children.find(l2 => l2.name === l2Name);
        this.activeLevel2 = level2;
      } else {
        this.activeLevel2 = null;
      }
    },
    // 删除一级 → 取消该一级下所有二级的勾选
    removeLevel1(level1ToRemove) {
      const toRemoveKeys = [];
      this.selectedSecondKeys.forEach(key => {
        const [l1Name] = key.split('-');
        if (l1Name === level1ToRemove.name) {
          toRemoveKeys.push(key);
        }
      });

      // 从 selectedSecondKeys 中移除
      this.selectedSecondKeys = this.selectedSecondKeys.filter(
        key => !toRemoveKeys.includes(key)
      );
    },

    // 删除二级 → 取消对应 checkbox 勾选
    removeLevel2(level1, level2) {
      const keyToRemove = this.genKey(level1, level2);
      this.selectedSecondKeys = this.selectedSecondKeys.filter(key => key !== keyToRemove);
    },
    // 单个 update
    updateDataCleaning(aaaId){
      this.dialogVisibleUpdate = true;
    },
    async toGetMenuList(){
      // let params = {};
      // if(this.type == 'single'){
      //   params = {
      //     aaaids: [this.aaaid],
      //   }
      // }else if(this.type == 'batch'){
      //   params = {
      //     aaaids: this.aaaid,
      //   }
      // }
      await getMenuList().then((res) => {
        console.log('update 结果', JSON.parse(JSON.stringify(res)));
        if(res.code == 200){
          this.menuList = res.data;
          // this.level3ListShowId = this.menuList[0].children[0].id;
          // this.level3List = this.menuList[0].children[0].children;
        }else{
          this.$message.error(res.msg);
        }
        
      });
    },
    handleCloseUpdate() {
      this.$emit('closeDialogVisibleUpdate');
      this.handleResetUpdate();
    },
    async handleDownload() {
      console.log('所有选中的二级 id', this.selectedNames);
      let params = {
        aaaids: this.aaaid,
        menuNames: this.selectedNames
      };
      console.log('download参数', params);
      await exportExcelData(params).then((res) => {
        console.log('exportExcelData 结果', JSON.parse(JSON.stringify(res)));
        // res.data 是一个 Blob 对象，不是字符串！
        const blob = new Blob([res.data], { type: 'application/zip' });

        // 创建下载链接
        const link = document.createElement('a');
        link.href = URL.createObjectURL(blob);
        link.download = 'download.zip'; // 可从 Content-Disposition 获取真实文件名

        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        URL.revokeObjectURL(link.href); // 释放内存
      });
    },
    handleResetUpdate(){
      this.dcDialogActiveNames = [0];
      this.selectedSecondKeys = [];
      this.selectedTreeData = [];
      // this.level3ListShowId = this.menuList[0].children[0].id;
      // this.level3List = this.menuList[0].children[0].children;
      this.searchKeyword = '';
    },
    async handleUpdate(){
      // this.$message.warning('更新则是和批量服务一样，发送一个订单到后台，人工上传。');
      let params = {
        updateCompanies: this.selectedCompanys,
        selections: this.selectedLevel1Names.join(','),
        taskId: this.taskId,
      }
      console.log('Update参数', params);
      await addMultiUpdateTask(params).then((res) => {
        console.log('addMultiUpdateTask', JSON.parse(JSON.stringify(res)));
        if(res.code == 200){
          this.$message.success(res.msg);
          // 关掉弹框，刷新二级列表
          this.$emit('closeSelectfiledRefresh');
          // 计算价格，暂时写死
          this.remindVisible = true;
          // this.calculatePriceFn();
          
        }else{
          this.$message.error(res.msg);
        }
      });
    },
    async calculatePriceFn(){
      let params = {
        aaaIds: this.aaaid,
        moduleIds: this.selectedLevel1Ids,
      }
      await calculatePrice(params).then((res) => {
        if(res.code == 200){
          this.calculatePriceRes = res.data;
        }else{
          this.$message.error(res.msg);
        }
      });
    },
    remindSubmit(){
      this.remindVisible = false;
      this.handleCloseUpdate();
    },
  },
};
</script>
<style scoped>
.dataCleaning-regenerate-dialog{
  display: flex;
  background: #F5F5F5;
  border-radius: 4px;
  height: 554px;
}
.dc-dialog-categoryField{
  width: 360px;
  border-right: 1px solid #ccc;
  flex-shrink: 0;
}
.dc-categoryField-filter{
  padding: 10px;
  height: 64px;
}
.dc-categoryField-filter /deep/ .el-input__inner{
  height: 40px;
  padding-left: 42px;
}
.dc-categoryField-filter /deep/ .el-input .el-icon-search:before{
  font-size: 22px;
  color: #999;
}
.dc-categoryField-filter /deep/ .el-input .el-input__prefix{
  left: 10px;
}
.dc-categoryField-filter /deep/ .el-input__inner::placeholder {
  font-size: 18px;
  color: #999999;
}
.dc-categoryField-filter.selectedShow {
  font-family: Arial Bold;
  padding: 20px 0 0 30px;
}
.dc-categoryField-collapse{
  border: 0;
}
.dc-categoryField-collapse /deep/ .el-collapse-item__header{
  font-size: 18px;
  color: #1A2332;
  line-height: 30px;
  padding: 7px 0px 4px 20px;
  border: 0;
  background: #F5F5F5;
}
.dc-categoryField-collapse /deep/ .el-collapse-item__header.is-active{
  color: #B98B73;
  background: #ffffff;
}
.dc-categoryField-collapse /deep/ .el-collapse-item__wrap{
  border: 0;
}
.dc-categoryField-collapse /deep/ .el-collapse-item__content{
  padding: 2px 5px 2px 20px;
}
.dc-categoryField-collapse /deep/ .el-collapse-item__arrow{
  font-size: 20px;
}
.dc-categoryField-checkbox /deep/ .el-checkbox .el-checkbox__label,
.dc-categoryField-checkbox-item{
  font-size: 18px;
  color: #1A2332;
  line-height: 30px;
}
.dc-categoryField-checkbox-item{
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 8px 0;
}
.dc-categoryField-checkbox-item /deep/ .el-checkbox__input{
  vertical-align: sub;
}

.dc-categoryField-checkbox-open{
  width: 20px;
  height: 30px;
  font-size: 20px;
  /* cursor: pointer; */
}
.dc-categoryField-checkbox-open.active{
  color: #B98B73;
}
.dc-dialog-subfield{
  width: 288px;
  border-right: 1px solid #ccc;
  flex-shrink: 0;
}
.dc-categoryField-scroll{
  height: 490px;
  overflow-y: auto;
}
.dc-categoryField-scroll.resultgap{
  padding: 0 20px;
}
.dc-categoryField-item{
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 8px 20px 0px 30px;
}
.dc-categoryField-item-sublist{
  padding-left: 10px;
}
.dc-categoryField-item-label{
  font-size: 18px;
  color: #1A2332;
  line-height: 30px;
  text-align: left;
  
  flex: 1;
}
.dc-categoryField-item-delete{
  width: 18px;
  height: 18px;
  background: #FF6A6A;
  text-align: center;
  border-radius: 50%;
  flex-shrink: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
}
.dc-categoryField-item-delete i{
  color: #fff;
  font-size: 14px;
  
}
.dc-dialog-field-selected{
  flex: 1;
}
.dc-download-btn{
  width: 210px;
  height: 60px;
  border-radius: 10px;
  border: 1px solid #B98B73;
  font-size: 20px;
  color: #B98B73;
}
.dc-update-btn{
  width: 210px;
  height: 60px;
  background: #B98B73;
  border-radius: 10px;
  font-size: 20px;
  color: #FFFFFF;
}
/* 数据服务-remind弹框 开始*/
.remindDialog /deep/ .el-dialog__body{
  overflow: unset;
}
.remindDialog /deep/ .el-dialog__header {
  text-align: center;
}
.remindDialog /deep/ .el-dialog__title {
  font-size: 20px;
  color: #1a2332;
  font-family: Arial;
}
.remindDialog .remind-list {
  background: #FAF1EC;
  border-radius: 10px;
  padding: 17px 18px 0;
}
.remindDialog .remind-item {
  background: #faf1ec;
  border-radius: 10px 10px 10px 10px;
  display: flex;
  align-items: center;
  padding: 0 0 15px;
}
.remindDialog .remind-item-title {
  font-size: 16px;
  color: #1a2332;
  width: 132px;
  margin-right: 8px;
}
.remindDialog .remind-item-num {
  font-size: 18px;
  color: #b98b73;
  width: 21px;
  text-align: right;
  white-space: nowrap;
  word-break: keep-all;
  display: flex;
  justify-content: flex-end;
}
.remindDialog .remind-item.cost .remind-item-title{
  font-weight: bold;
  width: auto;
}
.remindDialog .remind-item.cost .remind-item-num{
  font-weight: bold;
  width: auto;
}
.remindDialog .remind-tips {
  font-weight: bold;
  font-size: 16px;
  color: #1A2332;
  margin: 12px 0 38px;
}
.remindDialog .dc-remind-btn {
  width: 167px;
  height: 42px;
}
/* 数据服务-remind弹框 结束 */
</style>
